export var ANALYTICS_RESOLVING = 'resolving';
export var ANALYTICS_ERROR = 'errored';
export var ANALYTICS_FALLBACK = 'fallback';
export var ERROR_MESSAGE_OAUTH = 'Provider.authFlow is not set to OAuth2.';
export var ERROR_MESSAGE_FATAL = 'Fatal error resolving URL';
export var ERROR_MESSAGE_METADATA = 'Error resolving metadata.';